import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProductsList } from './products/ProductsList';
import { ProductForm } from './products/ProductForm';

export function Products() {
  return (
    <Routes>
      <Route index element={<ProductsList />} />
      <Route path="new" element={<ProductForm />} />
      <Route path=":id/edit" element={<ProductForm />} />
    </Routes>
  );
}